import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { CartContext } from '../../Context/CartContext.js';
import axios from 'axios';
import Loading from '../Loading/Loading.jsx';
import { CompanyContext } from '../../Context/CompanyContext.js';
import Swal from 'sweetalert2';
import Pagination from '../Pagination/Pagination.jsx';
import { UserContext } from '../../Context/UserContext.js';
import style from "./addTest.module.css";
import CustomTitle from '../CustomTitle/CustomTitle.jsx';



export default function AddTest() {
   const { id } = useParams();

   const { company, getCompany, loading } = useContext(CompanyContext);
   const [price, setPrice] = useState([]);
   const [error, setError] = useState(null);
   const [pageCount, setPageCount] = useState(0);

   const { addTest, removeTest } = useContext(CartContext);
   const { userToken } = useContext(UserContext);
   const header = {
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }




   function searchInput(e) {
      if (e.target.value.length > 2) {
         getData((e.target.value).toLowerCase());
      } else {
         setError(null);
         setPrice([]);
      }
   }

   //& Get All test And Search On Test By Test Name :
   async function getData(search) {
      let keyword = "";
      if (search) {
         keyword = `keyword=${search}`
      }

      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/price/getPriceCompany/${id}?${keyword}`, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               setError(null);
               setPrice(data?.prices);
               setPageCount(data.metadata.numberOfPages);
            }
         })
         .catch((error) => {
            setError(error.response?.data.message);
            setPrice([])

         })
   }


   useEffect(() => {
      getCompany(id)
   }, [])


   return (
      <Fragment>
         <CustomTitle title="أضافة تحاليل" />
         <div className="container  addTest my-5 pb-5 pt-1">
            <div className="row">
               <h4 className='main-header m-0'>أضافة الخدمات  </h4>
               <div className='under-header'></div>
               <hr className='main-color m-0' />

               <div className='d-flex justify-content-between align-items-center '>
                  <h4 >Company is : <span className='main-color'>{company.name}</span>   </h4>
                  <div className='w-25 text-center'>
                     <img src={company.logo} alt={company.name} className='w-50' />
                  </div>
               </div>

               <div className="">
                  <div className="">
                     <form action="">
                        <input type="search" onChange={(e) => { searchInput(e) }} className='form-control w-100 m-auto my-2 ' placeholder='اضافة خدمات جديدة' name="search" />
                     </form>
                  </div>
               </div>


               {error ? <> <div className='alert alert-danger'>{error}</div></> : <></>}
               {loading ? <Loading /> : <>
                  {price.map((ele) => {
                     return (
                        <div className={`${style.cardPrice} col-md-6 g-2`} key={ele._id}>
                           <div className="price_card p-1 m-1 px-2">
                              <div className='d-flex justify-content-between align-items-center'>
                                 <h6 className='main-color'><i className="fa-solid fa-flask-vial me-2"></i> {ele.testName.split(" ").map((ele) => ele.charAt(0).toUpperCase() + ele.slice(1)).slice(0, 6).join(" ")} </h6>
                                 <p className={`p-0 m-0`} dir='rtl'>
                                    <span className='text-success fw-bold'>{Math.round(ele.priceAfterDiscount)}  </span>
                                    <span className='mx-2'>بدلا من </span>
                                    <span className='text-danger fw-bold'>{Math.round(ele.price)}</span>
                                 </p>
                              </div>

                              <div className='d-flex justify-content-between align-items-center'>
                                 <button disabled={false} onClick={() => { addTest(ele.test, ele.company) }} className={`${style.cardBtn} btn bg-main  btn-sm`}>أضافة التحليل</button>
                                 <button disabled={false} onClick={() => { removeTest(ele.test) }} className={`${style.cardBtn} btn btn-danger  btn-sm`}>ألغاء التحليل</button>
                              </div>
                           </div>
                        </div>
                     )
                  })}
               </>
               }

            </div>
            <Link to={`/cart`} className='btn bg-main w-50 text-center my-4 m-auto d-block' >Complete Order</Link>
         </div>
      </Fragment>
   )
}